import Vue from 'vue';
import "core-js/stable";
import "regenerator-runtime/runtime";
import 'picturefill';
import axios from 'axios';
var timeout;
// グローバルナビコンポーネント
Vue.component('nav-accordion', {
	props: [ 'url', 'controls', 'class'],
	template: `
		<li class="_hasChildren" 
			:class="{'_isOpen' : isOpen}" 
			v-on:mouseenter="!isMobile && winWidth >= 768 ? mouseEnter() : null" 
			v-on:mouseleave="!isMobile && winWidth >= 768 ? mouseLeave() : null"
			>
			<a :href="url" :aria-controls="controls" 
				v-on:click="isMobile || winWidth < 768 ? accordionToggle($event) : null"
			>
				<slot name="trigger"></slot>
			</a>
			<slot name="target"></slot>
		</li>
		`,
	data() {
		return {
			isOpen: false,
			isMobile: false
		};
	},
	mounted() {
		this.$nextTick(function(){
			this.isMobile = headerVm.isMobile;
			this.winWidth = headerVm.winWidth;
		})
	},
	computed: {
		winWidth: function(){
			return headerVm.winWidth
		}
	},
	methods: {
		accordionToggle: function(event){
			if(event){
				event.preventDefault();
			}
			this.isOpen = !this.isOpen;
		},
		mouseEnter: function(){
			this.isOpen = true;
		},
		mouseLeave: function(){
			this.isOpen = false;
		}
	}
});

// ヘッダー設定
var headerVm = new Vue({
	el: '#header',
	data: {
		activeClass: '',
		isActive: false,
		isMobile: false,
		winWidth: window.innerWidth
	},
	created: function(){
		if (
			navigator.userAgent.indexOf('iPhone') > 0 ||
			navigator.userAgent.indexOf('Android') > 0 &&
			navigator.userAgent.indexOf('Mobile') > 0
		) {              
			this.isMobile = true;          
		} else if (
			navigator.userAgent.indexOf('iPad') > 0 || 
			navigator.userAgent.indexOf('Android') > 0
		) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	},
	methods: {
		toggleMenu: function(){
			this.isActive = !this.isActive;
			this.activeClass = this.isActive ? '_isOpen' : '_isClosed' ;
		},
		handleResize: function(){
			this.winWidth = window.innerWidth;
		}
		
	},
	mounted: function(){
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy: function(){
		window.removeEventListener('resize', this.handleResize)
	}
});
// カルーセル
import { 
	Hooper, 
	Slide,
	Navigation as HooperNavigation, 
    Pagination as HooperPagination
 } from 'hooper';

// スクロール時のアニメーション 
window.onload = () => {
	startObserve()
}
function startObserve(){
	// 各要素アニメーション追加用
	const callback = (entries, observer) => {
		entries.forEach(entry => {
			let ratio = entry.intersectionRatio;
			let classlist = entry.target.classList;
			if( ratio == 0 ){
				// 完全に見えない状態
			}else if (ratio <= 0.25){
				// 領域外に出るとき
				if(classlist.contains('_jsShow')){
					classlist.remove('_jsShow');
				}
			}else if (ratio > 0.25 && ratio <= 0.75 ) {
				// 領域内に入る時
				if(!classlist.contains('_jsShow')){
					classlist.add('_jsShow');
				}
			}
		})
	}
	const option = {
		threshold: [0, 0.25, 0.75, 1]
	};
	const observer = new IntersectionObserver( callback, option );
	const targets = document.getElementsByClassName('_jsEnter');
	for (let i = 0; i < targets.length; i++){
		observer.observe(targets[i]);
	}
	// トップからのスクロール位置計算用
	const dummyCallback = (entries, observer) => {
		entries.forEach(entry => {
			let ratio = entry.intersectionRatio;
			if(ratio == 0){
				footerVm.isHide = false;
			}else{
				footerVm.isHide = true;
			}
		})
	}
	const dummyObserver = new IntersectionObserver( dummyCallback, option );
	const dummyTarget = document.querySelector('#dummy');
	dummyObserver.observe(dummyTarget);
}

Vue.component('new-icon',{
	props: ['time'],
	data: function(){
		return {
			now: new Date().getTime()
		}
	},
	template:`
		<p v-if="isNew">New</p>
	`,
	computed: {
		isNew: function(){
			let entryTime = Date.parse(this.time);
			let offset = this.now - entryTime;
			if((offset / 24 / 60 / 60 / 1000) < 14){
				return true;
			}else{
				return false;
			}
		}
	},
})
// メインコンテンツ
let mainVm = new Vue({
	el: '#main',
	components: {
		Hooper,
		Slide,
		HooperNavigation,
		HooperPagination,
	},
	data: {
		hooperSettings: {
			itemsToShow: 1.5,
			infiniteScroll: true,
			wheelControl: false,
  			breakpoints: {
  				768: {
  					itemsToShow: 2
  				},
  				900: {
  					itemsToShow: 3
  				},
  				1200: {
  					itemsToShow: 3.5
  				}
  			}
		}
	}
});

// フッターコンテンツ
let footerVm = new Vue({
	el: '#footer',
	data: {
		isHide: true
	},
	methods: {
		scrollTop: function(){
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}
	}
});

// 会員情報
let memberVm = new Vue({
	el: '#member',
	data: {
		members: [],
		prefecture: [],
		consonant: [],
		filteredData: [],
		page: 1,
		perPage: 10,
		pages: []
	},
	mounted(){
		var target = document.getElementById('member');
		if(target){
			var jsonurl = target.dataset.json;
			axios
			.get(jsonurl)
			.then(response => (this.members = response.data))
			.catch(err => console.error(err))
		}
	},
	watch: {
		members(newVal, oldVal){
			this.showMembers();
		},
		page(){
			document.getElementById("member-result").scrollIntoView(true)
		}
	},
	methods: {
		// 会員情報を絞込
		showMembers(){
			this.page = 1;
			var arr = this.members;
			var prefArray = this.prefecture;
			var consArray = this.consonant;
			var filteredData = arr;
			if(prefArray.length){ // 都道府県で絞込
				var reg = new RegExp(prefArray);
				var filteredData = filteredData.filter(data => reg.test(data.prefecture));
			}
			// 名前で絞込
			var checkArray = [];
			if(consArray.length){
				if(consArray.includes('ア')){
					checkArray.push('ア','イ', 'ウ', 'エ', 'オ');
				}
				if(consArray.includes('カ')){
					checkArray.push('カ','キ', 'ク', 'ケ', 'コ');
				}
				if(consArray.includes('サ')){
					checkArray.push('サ','シ', 'ス', 'セ', 'ソ');
				}
				if(consArray.includes('タ')){
					checkArray.push('タ','チ', 'ツ', 'テ', 'ト');
				}
				if(consArray.includes('ナ')){
					checkArray.push('ナ','ニ', 'ヌ', 'ネ', 'ノ');
				}
				if(consArray.includes('ハ')){
					checkArray.push('ハ','ヒ', 'フ', 'ヘ', 'ホ');
				}
				if(consArray.includes('マ')){
					checkArray.push('マ','ミ', 'ム', 'メ', 'モ');
				}
				if(consArray.includes('ヤ')){
					checkArray.push('ヤ','ユ', 'ヨ');
				}
				if(consArray.includes('ラ')){
					checkArray.push('ラ','リ', 'ル', 'レ', 'ロ');
				}
				if(consArray.includes('ワ')){
					checkArray.push('ワ','オ', 'ン');
				}
				var checkedCons = checkArray.join('|');
				var reg = new RegExp(checkedCons);
				var filteredData = filteredData.filter(data => reg.test(data.name_kana.charAt(0)));
			}
			// console.log(filterdData);
			this.filteredData = filteredData;
			// 会員情報の件数に応じてページ数を設定
			let numberOfPages = Math.ceil(this.filteredData.length / this.perPage);
			this.pages = [];
			for (let index = 1; index <= numberOfPages; index++){
				this.pages.push(index);
			}
		},
		// ページ番号に合わせてデータを抽出
		paginate(data){
			let page = this.page;
			let perPage = this.perPage;
			let from = page * perPage - perPage;
			let to = page * perPage;
			return data.slice(from, to);
		}
	},
	computed: {
		// 表示するテストデータを抽出
		displayedData(){
			return this.paginate(this.filteredData);
		}
	}
});

// 会員紹介
let introduction = new Vue({
	el: '#introduction',
	data: {
		checkitems: [
			{
				consonant: 'a',
				initials: ['ア', 'イ', 'ウ', 'エ', 'オ'] 
			},
			{
				consonant: 'k',
				initials: ['カ', 'キ', 'ク', 'ケ', 'コ']
			},
			{
				consonant: 's',
				initials: ['サ', 'シ', 'ス', 'セ', 'ソ']
			},
			{
				consonant: 't',
				initials: ['タ', 'チ', 'ツ', 'テ', 'ト']
			},
			{
				consonant: 'n',
				initials: ['ナ', '二', 'ヌ', 'ネ', 'ノ']
			},
			{
				consonant: 'h',
				initials: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ']
			},
			{
				consonant: 'm',
				initials: ['マ', 'ミ', 'ム', 'メ', 'モ']
			},
			{
				consonant: 'y',
				initials: ['ヤ', 'ユ', 'ヨ']
			},
			{
				consonant: 'r',
				initials: ['ラ', 'リ', 'ル', 'レ', 'ロ']
			},
			{
				consonant: 'w',
				initials: ['ワ']
			}
		],
		members: [],
		fields: "",
		initial: [],
		keywords: "",
		filteredData: [],
		page: 1,
		perPage: 10,
		pages: []
	},
	mounted(){
		var target = document.getElementById('introduction');
		if(target){
			var jsonurl = target.dataset.json;
			axios
			.get(jsonurl)
			.then(response => (this.members = response.data))
			.catch(err => console.error(err))
		}
	},
	watch: {
		members(){
			this.showMembers()
		},
		page(){
			var pagenum = this.page;
			var pagearray = this.pages;
			document.getElementById("introduction-result").scrollIntoView(true)
		}
	},
	methods: {
		// 会員情報を絞込
		showMembers(){
			this.page = 1;
			var arr = this.members;
			var speciality = this.fields;
			var initialArray = this.initial;
			var keywordArray = this.keywords.split(' ');
			var filteredData = arr;
			if(speciality){ // 専門分野で絞込
				var filteredData = filteredData.filter(data => data.fields.some( data => data === speciality));
			}
			// 名前で絞込
			if(initialArray.length){
				var checkedInitials = initialArray.join('|');
				var reg = new RegExp(checkedInitials);
				var filteredData = filteredData.filter(data => reg.test(data.name_kana.charAt(0)));
			}
			// キーワードで絞り込み
			if(keywordArray.length){
				var array = keywordArray.join('|');
				var reg = new RegExp(array);
				var filteredData = filteredData.filter(data => reg.test([data.name_kana, data.name, data.kind_label, data.organization, data.fields]));
			}
			this.filteredData = filteredData;
			// 会員情報の件数に応じてページ数を設定
			let numberOfPages = Math.ceil(this.filteredData.length / this.perPage);
			this.pages = [];
			for (let index = 1; index <= numberOfPages; index++){
				this.pages.push(index);
			}
		},
		// ページ番号に合わせてデータを抽出
		paginate(data){
			let page = this.page;
			let perPage = this.perPage;
			let from = page * perPage - perPage;
			let to = page * perPage;
			return data.slice(from, to);
		}
	},
	computed: {
		// 表示するテストデータを抽出
		displayedData(){
			return this.paginate(this.filteredData);
		}
	}
});